import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "#1F2830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M8.25 19.25H2.447M20.25 8.75v-3a1.5 1.5 0 0 0-1.5-1.5H8.25v-1.5a1.5 1.5 0 0 0-1.5-1.5h-4.5a1.5 1.5 0 0 0-1.5 1.5v14.8a1.6998 1.6998 0 0 0 2.6353 1.396 1.7 1.7 0 0 0 .7007-.958l2.351-8.154A1.5 1.5 0 0 1 7.879 8.75H21.75a1.5002 1.5002 0 0 1 1.4713 1.2055 1.4987 1.4987 0 0 1-.0213.6805"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1F2830",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "m17.947 12.18 1.541 3.32h3a.7355.7355 0 0 1 .7104.4593.7351.7351 0 0 1-.1924.8237l-2.6 2.563 1.442 3.313a.7853.7853 0 0 1 .0396.4794.7857.7857 0 0 1-1.1586.5026l-3.489-1.958-3.487 1.961a.786.786 0 0 1-1.119-.982l1.443-3.313-2.6-2.563a.7337.7337 0 0 1 .0826-1.1675.7344.7344 0 0 1 .4284-.1185h3l1.544-3.323a.8.8 0 0 1 1.415.003Z"
})), 'FolderStarNew');